const API_PATHS = {
    CONTACT: "/addcontact", // Adjust as per your API
  };
  
  export default API_PATHS;
  